//Importaciones
import React, { useContext } from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import ListTemplate from '../../../../../Templates/List';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon, TooltipHost } from '@fluentui/react';
import './style.css'
import MainAppContext from '../../../../../../MainAppContext';
import i18next from 'i18next';

function ELEMENT_KPI_VARIABLE_DETAILS(props) {
    //Helpers
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_HideHeader = false,
        inputParam_ComponentContent = null,
        inputParam_UseFake = false,
        inputParam_Index = null
    } = props;

    const [data, setData] = useState(__OBJECT_STRUCTURE_GetList(15, !inputParam_UseFake ? ((inputParam_ComponentContent !== null  && inputParam_ComponentContent.items !== null) ? inputParam_ComponentContent.items : []) : [{
        elementName: "0000000 | Contrato",
        l_agg_vals: [{
            beginDate: '01/01/2024',
            dataserieId: 0,
            elementId: 0,
            elementName: "0000000 | Contrato",
            color: "na",
            desv: 0,
            desvPercent: 0,
            displayValue: 0,
            id: 0,
            serieTime: 0,
            serieTimeDT: null,
            serieTimeStr: null,
            v1: 0,
            v2: 0,
            valueGoal: 0,
            valueGoalPercent: 0,
            visibleFront: false
        }]
    }]));

    const renderContent = () => {
        return  <Row className='text-center px-1'>
                    <Col>
                        <ListTemplate
                            manipulateLocalData={ true }
                            className={"display-none no-compact-list"}
                            showHeaders={false}
                            isHeaderVisible={false}
                            listLocalStoragePageSizeVariableName="messageTree"
                            data={ (data.data !== null ? data : []) }
                            setData={ setData }
                            columns={ (data.data !== null) ? [
                                {
                                    key: 'variableName',
                                    name: t('data-lang-lbl-name'),
                                    fieldName: 'variableName',
                                    minWidth: 250,
                                    maxWidth: 250,
                                    onRender:(item) => {
                                        const fields = contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field);
                                        
                                        return  <div className={`h-1006 w-100`}>
                                                    <Row className="d-flex mx-0 border">
                                                        <Col style={{minWidth: "150px"}} className={`border-start border-end w-auto px-0`}>
                                                            {
                                                                (inputParam_Index === 0 || inputParam_UseFake) &&
                                                                <div style={{fontSize: "1rem"}} className="border-bottom">
                                                                    <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-name`) }</b></Col>
                                                                </div>
                                                            }
                                                            <div style={{fontSize: "12px", borderLeft: `10px solid`}} className={`my-1 px-3`}>
                                                                <TooltipHost content={item.elementName}>
                                                                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                    {item.elementName}
                                                                    </div>
                                                                </TooltipHost>
                                                            </div>
                                                        </Col>
                                                        {
                                                            fields.filter(x => (fields.length === 7 ? x !== "valueProvisory" : (fields.length === 6 ? (x !== "valueProvisory" && x !== "valueBudget") : (fields.length === 5 ? (x !== "valueProvisory" && x !== "valueBudget" && x !== "valueForecast") : (fields.length === 4 ? (x !== "valueProvisory" && x !== "valueBudget" && x !== "valueForecast" && x !== "valueReal") : (fields.length === 3 ? (x !== "valueProvisory" && x !== "valueBudget" && x !== "valueForecast" && x !== "valueReal" && x !== "displayValue") : (fields.length === 2 ? (x !== "valueProvisory" && x !== "valueBudget" && x !== "valueForecast" && x !== "valueReal" && x !== "displayValue" && x !== "valueGoal") : true))))) )).map((field, index) => (
                                                                <Col style={{minWidth: (index === 0) ? "100px" : "85px"}} className={
                                                                    `col-auto border-start border-end px-0 ${(fields.length !== index)? "px-0" : "ps-2" }`
                                                                    } key={index}>
                                                                    {
                                                                        (inputParam_Index === 0 || inputParam_UseFake) &&
                                                                        <div style={{fontSize: "1rem"}} className="border-bottom">
                                                                            <Col className="text-center"><b style={{fontSize: "14px"}}>{ t(`data-lang-lbl-field-${field}`) }</b></Col>
                                                                        </div>
                                                                    }
                                                                    {renderDatavalues((item.l_vals ? (item.l_vals.length > 0 ? item.l_vals : item.l_agg_vals) : item.l_agg_vals), field)}
                                                                </Col>
                                                            ))
                                                        }
                                                    </Row>
                                                </div>
                                    }
                                }                
                            ] : [] }
                            enableExport={ false }
                        />
                    </Col>
                </Row>
    }

    const renderDatavalues = (l_vals, field) => {
        return  <>
                {
                    l_vals.map((val, index) => (
                        <div style={{fontSize: "12px"}} key={index} className={`${(index !== l_vals.length -1) ? 'border-bottom' : ''} my-1 pe-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-text-color-" + val.color : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color-" + val.color : "" } `}>
                            {          
                                field === "serieTime" &&
                                <>
                                    {val["serieTimeStr"] !== null ? val["serieTimeStr"].toString() : val["serieTime"]}
                                </>
                            }
                            {
                                field !== "serieTime" &&
                                <>
                                    {`${val[field] !== undefined && val[field] !== null && !isNaN(val[field]) ? (field !== 'serieTime' ? parseFloat(val[field]).toLocaleString(i18next.language) : val[field])  : t('no-data')}`}
                                    {`${field.toLowerCase().indexOf('percent') !== -1 ? " %" : ""}`}
                                </>
                            }
                        </div>
                    ))
                }
                {
                    l_vals.length === 0 && 
                        <div style={{fontSize: "12px"}} className={`my-1 px-1 ${field.toLowerCase().indexOf('percent') !== -1 || field.toLowerCase().indexOf('time') !== -1 ? "text-center" : "text-end" } ${field.toLowerCase() === 'valuereal' || field.toLowerCase() === 'displayvalue' ? "variable-value-color" : "variable-value-color" } ${field.toLowerCase().indexOf('percent') !== -1 ? "variable-value-color" : "" } `}>{t('no-data')}</div>
                }
                </>
    }

    //Render de componente.
    return (
        <>
        {
            !inputParam_UseFake &&
            <Card className='h-100'>
                {
                    !inputParam_HideHeader &&
                    <Card.Header className="card-header-compact" style={{backgroundColor: "#115e8c", color: "white"}}>
                        <Card.Title className="d-flex justify-content-between">
                            <Row className='w-100 p-0'>
                                <Col className='d-flex align-items-center p-0'>
                                    <Icon className='ps-3' iconName='RingerSolid' styles={{root:{fontSize: "24px"}}} />
                                </Col>
                                <Col className='text-end col-auto ms-auto me-1 my-auto p-0'>
                                    { inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-coverage')}
                                </Col>
                            </Row>
                        </Card.Title>
                    </Card.Header>
                }
                <Card.Body className='p-0 h-100' style={{overflowY: "scroll", overflowX: "hidden"}}>
                    {renderContent()}
                </Card.Body>
            </Card> 
        }
        {
            inputParam_UseFake && renderContent()
        }
        </>
    );
}

export default ELEMENT_KPI_VARIABLE_DETAILS;